import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import SEO from "../common/SEO";
import AboutThree from "../component/about/AboutThree";
import CounterUpOne from "../component/counterup/CounterUpOne";
import ClientSlider from "../component/client/ClientSlider";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";

const MissionVision = () => {
  return (
    <>
      <SEO title="Mission & Vision" />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne
          subtitle=""
          title="Mission & Vision"
          page="Mission-vision"
        />
        <div
          className="container "
          style={{
            maxWidth: "800px",
            paddingTop: "70px",
            paddingBottom: "40px",
          }}
        >
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            Our Commitment to Excellence and Sustainability{" "}
          </h5>
          <p>
            At UCWF, our mission is to create a lasting, positive impact on the
            communities and industries we serve. Through innovation, operational
            excellence, and strategic collaboration, we strive to enhance the
            lives of our clients, business partners, and stakeholders. Our
            approach is rooted in sustainability, value creation, and an
            unwavering commitment to delivering exceptional service.{" "}
          </p>
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>Our Vision</h5>
          <p>
            To be a market leader in delivering cutting-edge facilities
            management solutions that align with global sustainability and
            innovation goals. We aim to exceed client expectations by being a
            trusted partner in creating smarter, greener, and more efficient
            environments, ensuring a sustainable future for the UAE and beyond.{" "}
          </p>
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            Inventive Solutions
          </h5>
          <p>
            We are committed to providing forward-thinking, customized solutions
            that go beyond contractual obligations. By leveraging the latest
            technologies and industry best practices, we ensure that our clients
            benefit from smarter, more sustainable outcomes that enhance
            efficiency and functionality.{" "}
          </p>
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            Sustainability at the Core{" "}
          </h5>
          <p>
            Environmental responsibility is at the heart of everything we do. As
            a certified Energy Services Company (ESCO), we implement proactive,
            science-driven strategies to address global energy challenges. Our
            commitment to sustainability is reflected in every service we offer,
            integrating energy-efficient practices to reduce environmental
            impact and promote long-term resource conservation. .
          </p>
          <h5 style={{ textAlign: "left", color: "#562b7a" }}>
            Cost-Effective, High-Quality Services{" "}
          </h5>
          <p>
            Delivering exceptional value is our priority. We provide premium
            facilities management services designed to optimize costs without
            compromising quality. Through streamlined processes and innovative
            strategies, we ensure our clients achieve maximum efficiency and
            return on investment while maintaining superior service standards.{" "}
          </p>
          <p>
            At UCWF, we offer a comprehensive range of services, including
            cleaning, security, MEP (Mechanical, Electrical, and Plumbing)
            services, energy management, and more. With over 300 active projects
            across diverse industries, we continue to redefine facilities
            management by creating sustainable, future-ready environments that
            enhance functionality and long-term value.{" "}
          </p>
        </div>

        <CounterUpOne />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />
        <AboutThree />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default MissionVision;
